module.exports = __webpack_public_path__ + "static/img/icon-sy.513bec38.png";